// web-vitals keeps observing INP/CLS/etc. for the whole SPA session and can throw
// asynchronously from its own timers during route-change-driven DOM churn; that is
// a known benign edge case in the library, not an app bug, so it must not surface
// as an uncaught console error.
window.addEventListener('error', (event) => {
  if (event.filename?.includes('web-vitals') || event.error?.stack?.includes('web-vitals')) {
    event.preventDefault()
  }
})

const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ onCLS, onINP, onFCP, onLCP, onTTFB }) => {
      try {
        onCLS(onPerfEntry)
        onINP(onPerfEntry)
        onFCP(onPerfEntry)
        onLCP(onPerfEntry)
        onTTFB(onPerfEntry)
      } catch (e) {
        console.warn('web-vitals reporting failed', e)
      }
    })
  }
}

export default reportWebVitals
